// apps/mediahaven2/src/bootstrap/services/app-initializer.service.ts
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { PortalConfigService } from '@common/services/config/portal-config.service';
import { AbstractBootstrapService } from '@mediahaven/shared';

@Injectable({ providedIn: 'root' })
export class BootstrapService extends AbstractBootstrapService {
    protected override readonly config: PortalConfigService = inject(PortalConfigService);

    /**
     * Initialize the application
     * Runs all required initialization tasks in sequence
     */
    public async initializeApp(): Promise<void> {
        await Promise.all([
            firstValueFrom(this.initializeTranslations()),
            firstValueFrom(this.initializeRouterState()),
            this.initializeMessageFormat()
        ]);
    }
}
